
$j(function($) {

  var tartanVal1 = $('#product-add-on-tartan').val();
  $('#product-variants-container').html('<input type="hidden" name="id[]" value="'+tartanVal1+'" />');

  $('#product-add-on-tartan').on('change', function() {
    var tartanVal2 = $(this).val();

    $('#product-variants-container').html('<input type="hidden" name="id[]" value="'+tartanVal2+'" />');
  });

  function handler1() {
    $(this).parent().find(".product-desc").removeClass("read-more");
    $(this).html("Read less");
    $(this).one("click", handler2);
  }

  function handler2() {
      $(this).parent().find(".product-desc").addClass("read-more");
    	$(this).html("Read more");
      $(this).one("click", handler1);
  }
  $(".template-product .btn-readmore").one("click", handler1);

  $("#size-chart img").on("click", function(){
  	$("#chartModal").css("display", "block");
    $("#chartImg").attr("src", this.src);
    $('body').css('overflow','hidden')
  });

  $("#chartModal .close").click(function(){
	$("#chartModal").css("display", "none");
    $('body').css('overflow-y','scroll')
  })

});

document.addEventListener("DOMContentLoaded", () => {

  $('.product-addons_container .product-form').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow: '<span class="slick-prev slick-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)"></path></svg></span>',
    nextArrow: '<span class="slick-next slick-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)"></path></svg></span>',
  });

  // add to cart function for UPSELL
  $(".template-product .product-form__cart-submit#AddToCart-product-template").click(function(e){

    // avoid multiple click and event call
    $(this).off("click");

    // this code prevents form from actually being submitted
    e.preventDefault();
    e.returnValue = false;


    if ( $(".product-addons_container").length ) {
      Shopify.queue = [];
      $(".template-product .product-addons_container .slider__item:not(.slick-cloned) input[type='checkbox']").each(function(){
        if( $(this).prop('checked') ){
          Shopify.queue.push( {
            variantId: $(this).val(),
            quantity: 1,
          });
        }
      });

      Shopify.moveAlong = function(){

        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          // code for upsell type product
          $.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {
              quantity: request.quantity,
              id: request.variantId
            },
            error: function(data, textstatus) {
              var parseddata = JSON.parse(data.responseText);

              if ( parseddata['status'] == 422 ) {
                console.log( parseddata['description'] );
              }
              Shopify.moveAlong();
            },
            always: function(data, textstatus) {
              Shopify.moveAlong();
            }
          });
        }else {
          $(".template-product .product-form.product-form-product-template").submit();
        }

      };
      Shopify.moveAlong();
    }else {
      // actually submit the form
      $(".template-product .product-form.product-form-product-template").submit();
    }

  });

  $('.measuremnt-form-file.btn-sizechart').on('click', function() {
    var modal_image = $(this).attr("data-img");
    var id = $(this).attr('href');
    $(id +'.size-chart-inner').html("<img style='display: block; margin: 0 auto;' src='" + modal_image + "'/>");
    $('#custom-builder-pop-up').fadeIn(200);
    $('#custom-builder-pop-up-bg').fadeIn(200);
	  $(id +'.size-chart-inner').fadeIn(200);
  });

  $('#custom-builder-pop-up-bg').on('click', function(e){
    e.preventDefault();
    $('.custom-builder-inner .page-width').html('');
    $('#custom-builder-pop-up').fadeOut(200);
    $('#custom-builder-pop-up-bg').fadeOut(200);
    $('.custom-builder-inner').fadeOut(200);
    $('.size-chart-inner').fadeOut(200);
  });

});